import { render } from "./RechargeValueComponent.vue?vue&type=template&id=ddcda05c&scoped=true"
import script from "./RechargeValueComponent.vue?vue&type=script&lang=js"
export * from "./RechargeValueComponent.vue?vue&type=script&lang=js"

import "./RechargeValueComponent.vue?vue&type=style&index=0&id=ddcda05c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddcda05c"]])

export default __exports__